import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/service/auth.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authService.getToken();

    // API 도메인 요청에만 withCredentials 적용 (쿠키 전송용)
    const isApiRequest = request.url.startsWith(environment.apiDomain);

    request = request.clone({
      ...(token && { setHeaders: { Authorization: `Bearer ${token}` } }),
      ...(isApiRequest && { withCredentials: true }),
    });

    return next.handle(request);
  }
}
